const maxWidth = window.matchMedia("(max-width: 700px)");
const video = document.getElementById("video");
const source = document.getElementById("source");
let videos = video?.getAttribute("data-videos");

let play = document.getElementById("play");
let pause = document.getElementById("pause");

let sound = document.getElementById("sound");
let muted = document.getElementById("muted");

let expand = document.getElementById("expand");

// Iphone does not support the full-screen api, hiding this for now
const agent = navigator.userAgent.toLowerCase();
const isIPhone = agent.indexOf('iphone') !== -1;
if (isIPhone && expand) expand.style.display = "none";

function setInitial() {
    play.style.display = "none";
    pause.style.display = "block";

    // remove sound button
    if (muted && sound) {
        muted.style.display = "none";
        sound.style.display = "none";

        if (video.muted) {
            video.muted = true;
            sound.style.display = "none";
            muted.style.display = "block";
        } else {
            sound.style.display = "block";
            muted.style.display = "none";
            video.muted = false;
        }
    }
}

if (video) {
    video.addEventListener("playing", () => setInitial(), false);
    video.addEventListener("expand", () => setInitial(), false);
    video.addEventListener("play", () => setInitial(), false);
}

if (videos) {
    videos = videos.split(",");

    if (maxWidth.matches) {
        video.pause();
        source.src = videos[0];
        video.load();
        video.play();
    } else {
        video.pause();
        source.src = videos.length > 1 ? videos[1] : videos[0];
        video.load();
        video.play();
    }
}

play && play.addEventListener("click", () => {
    play.style.display = "none";
    pause.style.display = "block";
    video.play();
});

pause && pause.addEventListener("click", () => {
    play.style.display = "block";
    pause.style.display = "none";
    video.pause();
});

expand && expand.addEventListener("click", () => {
    if (video.requestFullscreen) {
        video.requestFullscreen();
    } else if (video.webkitRequestFullscreen) {
        video.webkitRequestFullscreen();
    } else if (video.msRequestFullscreen) {
        video.msRequestFullscreen();
    }
});

sound && sound.addEventListener("click", () => {
    video.muted = !video.muted;
    sound.style.display = "none";
    muted.style.display = "block";
});

muted && muted.addEventListener("click", () => {
    video.muted = !video.muted;
    sound.style.display = "block";
    muted.style.display = "none";
});
